import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { range } from '@elliemae/ds-utilities/utils';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import moment from 'moment';
import { addLeadingZeros } from '@elliemae/ds-utilities/timeUtils';
import { isAM } from './utils.js';
import PickerPanel from './PickerPanel.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@babel/runtime/helpers/esm/toArray';
import 'lodash';
import 'memoize-one';
import '@elliemae/ds-icons/ChevronSmallUp';
import '@elliemae/ds-icons/ChevronSmallDown';
import '@elliemae/ds-button';
import './moveElementOnScroll.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var blockName = 'time-picker-menu';
var TimePickerContainer = aggregatedClasses('div')(blockName);
var TimePickerHeader = aggregatedClasses('div')(blockName, 'header');
var TimePickerPanelContainer = aggregatedClasses('div')(blockName, 'panel-container');

var generateOption = function generateOption(format) {
  return function (option) {
    return {
      value: option,
      label: typeof format === 'function' ? format(option) : option
    };
  };
};

var TimePickerMenu = /*#__PURE__*/function (_Component) {
  _inherits(TimePickerMenu, _Component);

  var _super = _createSuper(TimePickerMenu);

  function TimePickerMenu(props) {
    var _this;

    _classCallCheck(this, TimePickerMenu);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderHeader", function () {
      var time = _this.state.time;
      return /*#__PURE__*/React.createElement(TimePickerHeader, null, time.format('hh:mma'));
    });

    _this.state = {
      time: moment(props.time || '', props.format) || moment()
    };
    _this.handleHoursChange = _this.handleHoursChange.bind(_assertThisInitialized(_this));
    _this.handleMinuteChange = _this.handleMinuteChange.bind(_assertThisInitialized(_this));
    _this.handleSecondsChange = _this.handleSecondsChange.bind(_assertThisInitialized(_this));
    _this.handleAMPMChange = _this.handleAMPMChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TimePickerMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var time = this.state.time;
      this.setState({
        time: time
      });
    }
  }, {
    key: "handleMinuteChange",
    value: function handleMinuteChange(value) {
      var time = this.state.time;
      this.updateTime(time.minute(value));
    }
  }, {
    key: "handleHoursChange",
    value: function handleHoursChange(value) {
      var time = this.state.time;
      var use12Hours = this.props.use12Hours;
      var nextHour = value;

      if (use12Hours) {
        if (!isAM(time)) {
          nextHour = value % 12 + 12;
        }
      }

      this.updateTime(time.hour(nextHour));
    }
  }, {
    key: "handleSecondsChange",
    value: function handleSecondsChange(value) {
      var time = this.state.time;
      this.updateTime(time.second(value));
    }
  }, {
    key: "handleAMPMChange",
    value: function handleAMPMChange(value) {
      var time = this.state.time;
      var hour = time.hour();
      var nextHour = value.toLowerCase() === 'am' ? hour % 12 : hour % 12 + 12;
      this.updateTime(time.hour(nextHour));
    }
  }, {
    key: "updateTime",
    value: function updateTime(time) {
      var onTimeChange = this.props.onTimeChange;
      onTimeChange(time);
      this.setState({
        time: time
      });
    }
  }, {
    key: "renderHoursPanel",
    value: function renderHoursPanel() {
      var time = this.state.time;
      var _this$props = this.props,
          showHours = _this$props.showHours,
          use12Hours = _this$props.use12Hours,
          format = _this$props.format,
          hasHeader = _this$props.hasHeader,
          disabledTimes = _this$props.disabledTimes;
      if (!showHours) return null;
      var hour = time.hour(); // in 24 format

      var selectedHour = use12Hours ? hour % 12 || 12 : hour;

      if (disabledTimes) {
        var from = disabledTimes.from,
            to = disabledTimes.to;

        if (hour > from.hour && hour < to.hour) {
          if (to.hour < 24) {
            var toFormatted = to.hour % 12 || 12;
            if (selectedHour !== toFormatted) this.handleHoursChange(toFormatted);
            selectedHour = toFormatted;
          } else if (from) {
            selectedHour = (from.hour - 1) % 12 || 12;
          }
        }
      }

      var meridiem = hour >= 12 ? 'PM' : 'AM';
      var withLeadingZeros = format.indexOf('hh') > -1;
      var rangeHours = use12Hours ? range(1, 13) : range(24);
      var hoursOptions = rangeHours.map(generateOption(withLeadingZeros && addLeadingZeros(2)));
      return /*#__PURE__*/React.createElement(PickerPanel, {
        type: "hour",
        time: time,
        meridiem: meridiem,
        hasHeader: hasHeader,
        header: "H",
        onChange: this.handleHoursChange,
        options: hoursOptions,
        selected: selectedHour,
        disabledTimes: disabledTimes
      });
    }
  }, {
    key: "renderMinutesPanel",
    value: function renderMinutesPanel() {
      var time = this.state.time;
      var _this$props2 = this.props,
          showMinutes = _this$props2.showMinutes,
          format = _this$props2.format,
          hasHeader = _this$props2.hasHeader,
          disabledTimes = _this$props2.disabledTimes,
          minutesInterval = _this$props2.minutesInterval;
      if (!showMinutes) return null;
      var withLeadingZeros = format.indexOf('mm') > -1;
      var rangeMinutes = range(0, 60, minutesInterval).map(generateOption(withLeadingZeros && addLeadingZeros(2)));
      var selectedMinute = time.minute();
      var selectedHour = time.hour();

      if (disabledTimes) {
        var from = disabledTimes.from,
            to = disabledTimes.to;

        if (selectedHour <= to.hour && selectedHour > from.hour) {
          if (to) {
            if (selectedMinute < to.min) this.handleMinuteChange(to.min);
          } else if (from) {
            if (selectedMinute > from.min) this.handleMinuteChange(from.min - 1);
          }
        } else {
          selectedMinute = time.minute();
        }
      }

      return /*#__PURE__*/React.createElement(PickerPanel, {
        type: "minutes",
        time: time,
        hasHeader: hasHeader,
        header: "M",
        onChange: this.handleMinuteChange,
        options: rangeMinutes,
        selected: selectedMinute,
        disabledTimes: disabledTimes
      });
    }
  }, {
    key: "renderSecondsPanel",
    value: function renderSecondsPanel() {
      var time = this.state.time;
      var _this$props3 = this.props,
          showSeconds = _this$props3.showSeconds,
          format = _this$props3.format,
          hasHeader = _this$props3.hasHeader;
      if (!showSeconds) return null;
      var withLeadingZeros = format.indexOf('ss') > -1;
      var rangeSeconds = range(60).map(generateOption(withLeadingZeros && addLeadingZeros(2)));
      return /*#__PURE__*/React.createElement(PickerPanel, {
        type: "seconds",
        hasHeader: hasHeader,
        header: "S",
        onChange: this.handleSecondsChange,
        options: rangeSeconds,
        selected: time.second()
      });
    }
  }, {
    key: "renderAMPMPanel",
    value: function renderAMPMPanel() {
      var time = this.state.time;
      var _this$props4 = this.props,
          use12Hours = _this$props4.use12Hours,
          hasHeader = _this$props4.hasHeader,
          disabledTimes = _this$props4.disabledTimes;
      if (!use12Hours) return null;
      var meridiemSelected = !isAM(time) ? 'pm' : 'am';

      if (disabledTimes && disabledTimes.to && meridiemSelected === 'am') {
        meridiemSelected = disabledTimes.to.hour >= 12 ? 'pm' : 'am';

        if (meridiemSelected === 'am' && time.hour() > 12) {
          this.handleAMPMChange('am');
        }

        if (meridiemSelected === 'pm' && time.hour() <= 12) {
          this.handleAMPMChange('pm');
        }
      }

      return /*#__PURE__*/React.createElement(PickerPanel, {
        type: "meridiem",
        hasHeader: hasHeader,
        header: "",
        onChange: this.handleAMPMChange,
        options: [{
          value: 'am',
          label: 'am'
        }, {
          value: 'pm',
          label: 'pm'
        }],
        selected: meridiemSelected,
        disabledTimes: disabledTimes
      });
    }
  }, {
    key: "render",
    value: function render() {
      var hasHeaderDisplay = this.props.hasHeaderDisplay;
      return /*#__PURE__*/React.createElement(TimePickerContainer, null, hasHeaderDisplay && this.renderHeader(), /*#__PURE__*/React.createElement(TimePickerPanelContainer, null, this.renderHoursPanel(), this.renderMinutesPanel(), this.renderSecondsPanel(), this.renderAMPMPanel()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.time) {
        return _objectSpread(_objectSpread({}, state), {}, {
          time: moment(props.time)
        });
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        time: undefined
      });
    }
  }]);

  return TimePickerMenu;
}(Component);

TimePickerMenu.defaultProps = {
  time: moment(),
  hasHeader: false,
  use12Hours: true,
  showSeconds: true,
  showMinutes: true,
  showHours: true,
  disabledTimes: undefined,
  onTimeChange: function onTimeChange() {
    return null;
  }
};
TimePickerMenu.propTypes = {
  /** Time value */
  time: PropTypes.instanceOf(moment),

  /** If the menu has header or not */
  hasHeader: PropTypes.bool,

  /** Whether to use the 12 hours format */
  use12Hours: PropTypes.bool,

  /** Whether show 'seconds' or not */
  showSeconds: PropTypes.bool,

  /** Whether show 'minutes' or not */
  showMinutes: PropTypes.bool,

  /** Whether show 'hours' or not */
  showHours: PropTypes.bool,

  /** Handler when time changes */
  onTimeChange: PropTypes.func,
  disabledTimes: PropTypes.object
};

export default TimePickerMenu;
export { TimePickerMenu };
//# sourceMappingURL=TimePickerMenu.js.map
